(function () {
	'use strict';

	angular
		.module('invesfleet')
		.factory('zonaService', zonaService);

	zonaService.$inject = ['$http', '$q', 'endPoints', 'authorization'];

	function zonaService($http, $q, endPoints, authorization) {
		var service = {
            getList: getList,
            pointInZone: pointInZone,
		};

		return service;


		function getList(sorting, filters) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.zonas.getAll
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
        }

        function pointInZone(latitude, longitude) {
            var params = "latitude=" + latitude + "&longitude=" + longitude; 
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.zonas.pointInZone + "?" + params
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
                function (response) {
                    deferred.reject(null);
                });
            return deferred.promise;
        }
	}

})();